export function createAlignedClockTick(onTick) {
  let timer = null;

  const tick = () => {
    if (typeof onTick === 'function') {
      onTick();
    }
    const now = Date.now();
    const delay = 1000 - (now % 1000);
    timer = setTimeout(tick, delay);
  };

  return {
    start() {
      this.stop();
      tick();
    },
    stop() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    },
  };
}
